import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from 'lib-base';


@Injectable({
  providedIn: 'root'
})
export class FirmaElectronicaTokenService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/firma-electronica-token`;
  }

  enviarTokenCorreoFirmaElectronica(tramRegistroTmpId: number, medio: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/enviar-token-declaracion-firma-electronica/${tramRegistroTmpId}/${medio}`, {});
  }

  usuarioTieneFirmaElectronicaActiva(): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/usuario-tiene-firma-electronica-activa`);
  }
}
